function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';
import Pane from './Pane';
import Panes from './Panes';
import Tab from './Tab';
import Tabs from './Tabs';
export var context = createContext({});
var Provider = context.Provider;
/**
 * A TabSwitcher wraps all the logic between tabs (elements allowing to display content)
 * and panes (content displayable when its tab is clicked)
 *
 * @return {jsx}
 */

var TabSwitcher = function TabSwitcher(_ref) {
  var children = _ref.children,
      defaultTabId = _ref.defaultTabId,
      tabId = _ref.tabId,
      onChange = _ref.onChange;
  var isControlled = tabId != null;

  var _useState = useState(defaultTabId),
      _useState2 = _slicedToArray(_useState, 2),
      activeTabId = _useState2[0],
      setActiveTabId = _useState2[1];

  return /*#__PURE__*/React.createElement(Provider, {
    value: {
      activeTabId: isControlled ? tabId : activeTabId,
      onTabChange: function onTabChange(id) {
        onChange && onChange(id);

        if (!isControlled) {
          setActiveTabId(id);
        }
      }
    }
  }, children);
};

TabSwitcher.displayName = 'TabSwitcher';
TabSwitcher.Pane = Pane;
TabSwitcher.Panes = Panes;
TabSwitcher.Tab = Tab;
TabSwitcher.Tabs = Tabs;
/**
 * PropTypes Validation
 */

var func = PropTypes.func,
    node = PropTypes.node,
    string = PropTypes.string;
TabSwitcher.propTypes = {
  /** Tabs and Panes to be displayed. */
  children: node.isRequired,

  /** Starts the tab at a specific id */
  defaultTabId: string,

  /** Callback with the tab id triggered when the user changes tabs allowing your app to synchronize with it */
  onChange: func,

  /** Like form inputs, a tab's state can be controlled by the owner */
  tabId: function tabId(props, name, compName) {
    if (props.tabId != null && props.onChange == null) {
      return new Error('You provided an `tabId` prop to `TabSwitcher` without an `onChange` handler. This will render a read-only tabs element. If the tabs should be mutable use `defaultTabId`. Otherwise, set `onChange`.');
    } else {
      for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        rest[_key - 3] = arguments[_key];
      }

      return string.apply(void 0, [name, props, compName].concat(rest));
    }
  }
};
/**
 * Default props.
 */

TabSwitcher.defaultProps = {
  defaultTabId: undefined,
  tabId: undefined,
  onChange: undefined
};
export default TabSwitcher;